/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { axiosProtectedApi, axiosWebservice } from './setup';
import qs from 'qs';

export async function getMeetingCredentials (meetData) {
  const api = axiosProtectedApi();
  const response = await api.post('meet/token', qs.stringify(meetData));
  return response && response.data && response.data.status
    ? response.data
    : null;
}

export async function getFreeMeetingCredentials (meetData) {
  const webservice = axiosWebservice();
  try {
    const response = await webservice.post(
      'freeclient/gettoken',
      qs.stringify(meetData)
    );
    return response && response.data && response.data.status
      ? response.data
      : null;
  } catch (error) {
    return error.response.status;
  }
}

export async function getParticipants ({ confId, callId }) {
  const api = axiosProtectedApi();
  const response = await api.post(
    'meet/participants',
    qs.stringify({ confid: confId, callid: callId })
  );
  return response && response.data && response.data.status && response.data.data
    ? response.data.data
    : [];
}

export async function getFreeMeetingParticipants ({ confId, callId }) {
  const webservice = axiosWebservice();
  const response = await webservice.post(
    'freeclient/get_participants',
    qs.stringify({ confid: confId, callid: callId })
  );
  return response && response.data && response.data.status && response.data.data
    ? response.data.data
    : [];
}

export async function getUserByRoomNumber (room) {
  const webservice = axiosWebservice();
  const response = await webservice.get(
    `freeclient/user/${room}`
  );
  try {
    return response && response.data && response.data.status
      ? response.data.data
      : null;
  } catch (error) {
    return null;
  }
}
